"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalization = exports.LocalizationProvider = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const message_definitions_1 = __importDefault(require("./messages/message-definitions"));
const hooks_1 = require("../hooks");
// Webpack excludes dynamically imported JSON files from the bundle. Temporary workaround
const messagePathMap = {
    'en-US': () => Promise.resolve().then(() => __importStar(require('./messages/compiled/en-US.json'))),
};
const loadCompiledMessages = (languageCode, defaultLanguage) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const loadMessages = messagePathMap[languageCode];
        const messages = yield loadMessages();
        return messages.default;
    }
    catch (err) {
        const loadMessages = messagePathMap[defaultLanguage];
        const defaultMessages = yield loadMessages();
        return defaultMessages;
    }
});
const LocalizationProvider = ({ children }) => {
    const { selectedLanguage, defaultLanguage } = (0, hooks_1.useLanguage)();
    const [messages, setMessages] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const action = () => __awaiter(void 0, void 0, void 0, function* () {
            setMessages(yield loadCompiledMessages(selectedLanguage, defaultLanguage));
        });
        void action();
    }, [selectedLanguage]);
    return (react_1.default.createElement(ui_components_1.LocalizationProvider, { locale: selectedLanguage, defaultLocale: defaultLanguage, messages: messages }, children));
};
exports.LocalizationProvider = LocalizationProvider;
const useLocalization = () => {
    const _a = (0, ui_components_1.useLocalization)(), { formatMessage: baseFormatMessage } = _a, rest = __rest(_a, ["formatMessage"]);
    // Overloads formatMessage to return `string` for primitive values and `ReactNode` for rich content.
    // Uses a generic implementation signature to satisfy both overloads
    const formatMessage = (0, react_1.useCallback)((message) => {
        const messageDefinition = message_definitions_1.default[message.key];
        if ((0, ramda_1.isNil)(messageDefinition)) {
            return message.key;
        }
        return baseFormatMessage(messageDefinition, message.values);
    }, [baseFormatMessage]);
    return Object.assign(Object.assign({}, rest), { formatMessage });
};
exports.useLocalization = useLocalization;
